<template>
  <pt-label-manage class="pt-label-manage__withData" @deleteLabel="deleteLabel" ref="labelMessage"></pt-label-manage>
</template>

<script>
import PtLabelManage from './index'
export default {
  name: 'pt-label-manage__withData',
  components: {
    'pt-label-manage': PtLabelManage
  },
  methods: {
    deleteLabel (id) {
      this.$store.dispatch('deleteLabel', id).then(res => {
        this.$message.success('删除标签成功')
        this.$refs.labelMessage.getTableData()
      }).catch(err => {
        this.$message.error(err || '删除标签失败')
      })
    }
  }
}
</script>
